import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type IsGeneratedPassphrase_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', isGeneratedPassphrase?: boolean | null };

export type IsGeneratedPassphrase_CollectionShare_Fragment = { __typename?: 'CollectionShare', isGeneratedPassphrase?: boolean | null };

export type IsGeneratedPassphraseFragment = IsGeneratedPassphrase_AdHocAssetsShare_Fragment | IsGeneratedPassphrase_CollectionShare_Fragment;

export const IsGeneratedPassphrase = /*#__PURE__*/ gql`
    fragment IsGeneratedPassphrase on Share {
  isGeneratedPassphrase @client
}
    ` as unknown as DocumentNode<IsGeneratedPassphraseFragment, unknown>;

        

        
export const useIsGeneratedPassphraseFragment = (
  input: string | Omit<UseFragmentOptions<IsGeneratedPassphraseFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Share' } };
    return input;
  })();

  return useFragment<IsGeneratedPassphraseFragment>({
    fragment: IsGeneratedPassphrase,
    fragmentName: 'IsGeneratedPassphrase',
    ...options,
  });
};
  
        